import { render, staticRenderFns } from "./CCMAttachments.vue?vue&type=template&id=51f0dd3a"
import script from "./CCMAttachments.vue?vue&type=script&lang=js"
export * from "./CCMAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports